import {produce} from 'immer'

import {useCallback, useMemo, useState} from 'react'

import {generateUID} from '../../../../../../../../utils/uid'

import type {
  PipelineParameterValue,
  PipelineParameterValueArg,
} from './PipelineParameterCreateForm.types'

const defaultParameterForm: PipelineParameterValue = {
  name: '',
  value: '',
  id: '0',
}

function usePipelineParameterCreateForm(
  onDeleteAll: () => void,
  onConfirm: (value: PipelineParameterValueArg[]) => void,
) {
  const [parametersValid, setParametersValid] = useState<boolean[]>([])
  const [newParameterForms, setNewParameterForms] = useState<PipelineParameterValue[]>([
    {...defaultParameterForm},
  ])
  const confirmFormButtonClickHandler = useCallback(() => {
    onConfirm(
      newParameterForms.map(({name, value}) => ({
        name,
        value,
      })),
    )
  }, [newParameterForms, onConfirm])
  const changeFormFieldsetHandler = (index: number) => (name: string, value: string) => {
    setNewParameterForms(state =>
      produce(state, draft => {
        draft[index] = {
          ...draft[index],
          name,
          value,
        }
      }),
    )
  }
  const newParameterNames = useMemo(
    () => newParameterForms.map(({name}) => name),
    [newParameterForms],
  )
  const addParameterButtonClickHandler = () =>
    setNewParameterForms(state => [...state, {...defaultParameterForm, id: generateUID()}])
  const validFormFieldsetHandler = (index: number) => (isValide: boolean) =>
    setParametersValid(state =>
      produce(state, draft => {
        draft[index] = isValide
      }),
    )
  const isOnlyOneParameter = newParameterForms.length === 1
  const deleteFormButtonClickHandler = isOnlyOneParameter ? undefined : onDeleteAll
  const deleteParameterButtonClickHandler = (index: number) => () => {
    setNewParameterForms(newParameterForms.filter((_, indexParam) => indexParam !== index))
    // setNewParaneteForm(state => state.filter((_, indexParam) => indexParam !== index))
    setParametersValid(parametersValid.filter((_, indexParam) => indexParam !== index))
    if (isOnlyOneParameter) {
      onDeleteAll()
    }
  }
  const isFormInvalid = useMemo(() => parametersValid.some(state => !state), [parametersValid])
  const keyPressParameterInputHandler = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' && !isFormInvalid) {
        event.preventDefault()
        confirmFormButtonClickHandler()
      }
    },
    [isFormInvalid, confirmFormButtonClickHandler],
  )

  return {
    isFormInvalid,
    newParameterNames,
    newParameterForms,
    validFormFieldsetHandler,
    changeFormFieldsetHandler,
    confirmFormButtonClickHandler,
    keyPressParameterInputHandler,
    deleteFormButtonClickHandler,
    addParameterButtonClickHandler,
    deleteParameterButtonClickHandler,
  }
}

export default usePipelineParameterCreateForm
